import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const shortnessOfBreath: AnswerPathTreeNode = {
  path: 'shortnessOfBreath',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredShortnessOfBreathDetails }],
};
